import { useEffect, useState } from 'react';
import { Menu } from '@mui/material';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import { Button, Checkbox } from 'ui';

import { useTags } from '../../store/tags/hook';

const TagsFilter = (props) => {
  const { selectedTagIds, onSelect } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIds, setSelectedIds] = useState(selectedTagIds);
  const { loading, tags } = useTags();

  const open = Boolean(anchorEl);

  useEffect(() => {
    // Needed to reconcile the initial state of the dropdown with the current
    // state of the fields when the dropdown is closed and reopened.
    // Use case: user toggles local state selection but does not apply the changes.
    if (!open) {
      setSelectedIds(selectedTagIds);
    }
  }, [open, selectedTagIds]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleInputChange = (tagId) => {
    setSelectedIds((prev) => (prev.includes(tagId) ? prev.filter((id) => id !== tagId) : [...prev, tagId]));
  };

  const handleApply = () => {
    onSelect(selectedIds);
    handleClose();
  };

  return (
    <>
      <Button
        title="Tags"
        className={selectedTagIds.length > 0 ? 'border-primary-200 !bg-primary-50' : ''}
        RightIcon={open ? IconChevronUp : IconChevronDown}
        onClick={handleClick}
        loading={loading}
      />

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        classes={{
          paper: 'w-[320px] max-h-[412px] !rounded-lg mt-0.5 !overflow-hidden',
          list: '!p-0',
        }}
      >
        <ul className="max-h-[340px] space-y-3 overflow-y-auto p-4">
          {tags.map((tag) => (
            <li key={tag.id}>
              <Checkbox
                id={tag.id}
                name={tag.name}
                label={tag.name}
                value={tag.id}
                checked={selectedIds.includes(tag.id)}
                onChange={() => handleInputChange(tag.id)}
              />
            </li>
          ))}
        </ul>

        <li className="border-t border-gray-50 p-4">
          <Button title="Apply" color="primary" onClick={handleApply} className="w-full" />
        </li>
      </Menu>
    </>
  );
};

TagsFilter.propTypes = {
  selectedTagIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default TagsFilter;
